import React from 'react';
import PropTypes from 'prop-types';

const LiveFilter = ({
  filters,
  onFilterSelected,
  downloadAll,
}) => (
  <div className="review-filter">
    {filters.map(btn => (
      <span className="container-menu-button">
        <button
          key={`index_${btn.filter}`}
          type="button"
          className={`menu-button${btn.active === true ? ' active' : ''}`}
          onClick={() => onFilterSelected(btn.filter)}
        >
          <span>{btn.title}</span>
        </button>
      </span>
    ))}
    <button type="button" className="download-all-button" onClick={downloadAll}>
      <span>Descargar Todo</span>
    </button>
  </div>
);

LiveFilter.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    filter: PropTypes.string,
    active: PropTypes.bool,
  })).isRequired,
  onFilterSelected: PropTypes.func.isRequired,
  downloadAll: PropTypes.func.isRequired,
};

export default LiveFilter;
